import { render, staticRenderFns } from "./trend-up.vue?vue&type=template&id=0b5b297b&"
import script from "./trend-up.vue?vue&type=script&lang=js&"
export * from "./trend-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5b297b')) {
      api.createRecord('0b5b297b', component.options)
    } else {
      api.reload('0b5b297b', component.options)
    }
    module.hot.accept("./trend-up.vue?vue&type=template&id=0b5b297b&", function () {
      api.rerender('0b5b297b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/trend-up.vue"
export default component.exports